<template>
	<div class="main">
		<div class="image">
			<img src="@/assets/now_1.png" />
		</div>
		<div class="live">
			Live Happy. Live Healthy. Live NOW.
		</div>
		<div class="live-translate">
			<div>Живи щасливо.</div>
			<div>Живи здорово.</div>
			<div>Живи ЗАРАЗ.</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'HeaderAds',
}
</script>

<style lang="scss" scoped>
.main {
	display: flex;
	justify-content: space-around;
	padding: 5px 30px;
	align-items: center;
	background-color: #ef571f;
	border-radius: 5px;
	margin-top: 5px;

	.image {
		max-width: 150px;
		
		img {
			max-width: 100%;
		}
	}

	.live {
		color: white;
		font-size: 35px;
		letter-spacing: 0.5px;
	}

	.live-translate {

		color: white;
	}

	@media (max-width:580px) {
		.main {
			justify-content: space-between;
			padding: 5px 10px;
		}

		.image {
			max-width: 50px;
		}

		.live {
			font-size: 12px;
			letter-spacing: 0px;
		}
		.live-translate {
			font-size: xx-small;
		}
	}
}
</style>